import styled from 'styled-components';
import { ISubtitle } from './interface';

const title = styled.h1`
  font-size: 1.5rem;
  white-space: nowrap;
  font-weight: bold;
  color: ${(props) => props.theme.colors.mainColor};
`;

const label = styled.h3`
  font-size: 1rem;
  margin: 0;
  white-space: nowrap;
  font-weight: 500;
  color: inherit;
  padding-left: 10px;
  padding-right: 10px;
`;

const labelH3 = styled.h3`
  width: 250px;
  font-size: 0.75rem;
  margin: 0;
  word-break: break-word;
  line-height: 1.15rem;
  white-space: nowrap;
  font-weight: 500;
  color: inherit;
  white-space: pre-line;
  min-height: 60px;
  padding-bottom: 10px;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
`;
const labelUh3 = styled.h3`
  width: 200px;
  font-size: 0.75rem;
  margin: 0;
  height: 60px;
  word-break: break-word;
  line-height: 1.5rem;
  font-weight: 500;
  color: inherit;
  padding-left: 10px;
  padding-right: 10px;
`;
const mainLabel = styled.h2`
  font-size: 1.125rem;
  white-space: nowrap;
  color: ${(props) => props.theme.colors.mainColor};
  font-weight: 600;
  margin: 0;
`;

const subtitle = styled.h4<ISubtitle>`
  font-size: 0.875rem;
  color: ${(props) => props.color};
  margin: ${(props) => props.theme.margin.min};
`;

const Text = {
  Title: title,
  MainLabel: mainLabel,
  Label: label,
  LabelC: labelH3,
  LabelU: labelUh3,
  Subtitle: subtitle,
};

export default Text;
